import { promoUp as e } from "../index.js";
const a = e.teaser, t = a.pointsTeaserVariationChange, o = a.articleTeaserVariationChange;
export {
  o as articleTeaserVariationChange,
  t as pointsTeaserVariationChange,
  a as teaser
};
/*                             */
